module.exports = __webpack_public_path__ + "cement/img/组 539@2x.9daa8acf.png";